import type { ReactElement } from 'react';
import { mergeSx } from 'components/ui/utilities/mergeSx';
import { InputProps } from './Input.props';
import { inputCompactOutlinedSx, StyledInput } from './Input.styles';

const inputVisualVariantSx = {
  compactOutlined: inputCompactOutlinedSx,
} as const;

const Input = ({ sx, variant = 'outlined', visualVariant, ...props }: InputProps): ReactElement => {
  const presetSx = visualVariant ? inputVisualVariantSx[visualVariant] : undefined;
  const mergedSx = mergeSx(presetSx, sx);

  return <StyledInput fullWidth sx={mergedSx} variant={variant} {...props} />;
};

export default Input;
